import React from "react";
import { View, Image, useWindowDimensions } from "react-native";
import TitleText from "./TitleText";
import NormalText from "./NormalText";
import { BackgroundDark, BackgroundLight } from "../../../assets";

const DrFanRecommendation = () => {
  const { width } = useWindowDimensions();
  const isMobile = width < 850;

  return (
    <View
      style={{
        flex: 1,
        position: "relative",
        backgroundColor: "#E8F9FF",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,
        borderRadius: isMobile ? 10 : 0,
        gap: isMobile ? 20 : 50,
      }}
    >
      <TitleText
        text={
          "“ClinicOS ensures our patients are happier with their post-op care while giving us a constant flow of high quality post-op images for marketing.”"
        }
        numberOfLines={20}
        fontWeight="600"
        style={{
          color: "#024767",
          textAlign: "center",
          fontSize: isMobile ? 18 : 38,
        }}
      />
      <View
        style={{
          gap: 10,
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Image
          source={{
            uri: "https://clinic-os.com/user-app-assets/dr-fan-pic-0001.png",
          }}
          style={{ width: isMobile ? 75 : 150, height: isMobile ? 75 : 150 }}
        />
        <View>
          <NormalText
            text={"Dr. Larry Fan,"}
            fontWeight="600"
            style={{
              color: "#024767",
              fontSize: isMobile ? 16 : 20,
            }}
          />
          <Image
            source={{
              uri: "https://clinic-os.com/user-app-assets/77-plastic-surgery-logo-0001.png",
            }}
            style={{ width: isMobile ? 145 : 165, height: isMobile ? 30 : 40 }}
          />
        </View>
      </View>
      {!isMobile && (
        <React.Fragment>
          <View
            style={{
              position: "absolute",
              bottom: 0,
              right: 0,
              zIndex: 1,
            }}
          >
            <BackgroundDark />
          </View>
          <View
            style={{
              position: "absolute",
              bottom: 0,
              right: 0,
            }}
          >
            <BackgroundLight />
          </View>
        </React.Fragment>
      )}
    </View>
  );
};

export default DrFanRecommendation;
